import { ComponentType, PageType } from '../enums';
import { sortOpen } from 'store/search/searchActions';
import { createSortOpenEvent } from '../eventCreators';
import { createSortOpenEventPayload } from '../dataHelpers/createSortOpenEventPayload';

const emitSortOpenEvent = () => {
  return createSortOpenEvent(
    createSortOpenEventPayload({
      componentVariant: 'search results sort',
      componentType: ComponentType.SORT,
      pageType: PageType.SEARCH,
    }),
  );
};

export default { [sortOpen.type]: emitSortOpenEvent };
